var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',{staticClass:"grey lighten-4",attrs:{"app":""}},[_c('v-container',{staticClass:"px-8 py-6",attrs:{"fluid":""}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }